import React from 'react';
import translations from '../../utils/translations';

const GenericError = () => {
    const title = translations['th.inbox.error.title'];
    const message = translations['th.inbox.error.message'];
    const errorStyle = {
        paddingTop: '40px',
        paddingBottom: '40px'
    };

    return (
        <div className="row text-center" style={errorStyle}>
            <svg className="inline-svg svg-xl svg-warning ">
                <use xlinkHref="#svg-alert"/>
            </svg>
            <h3>{title}</h3>
            <p>{message}</p>
        </div>
    );
};

export default GenericError;


// WEBPACK FOOTER //
// ./src/universal/components/generic-error/generic-error.js